<template>
    <form class="fiber_cabling_installation mt-3 col-12 col-md-6 col-lg-5">
        <template v-for="(item, index) in planDataFromMagento.plan.installation"  :key="index">
            <div v-if="formatPrice(item.installation_price)"
                class="form__fiber c-plan-form__subtitle-container mt-3">
                <div class="c-fiber-form__subtitle-container u-flex">


                    <div class="text-left">
                        <h3> {{ item.installation_title }}</h3>
                        <div class="c-fiber-form__inline-block- u-grey-text u-pad-t-xs">
                            <p v-html="item.installation_description"></p>
                        </div>
                    </div>

                    <div class="ml-auto">
                        <div class="u-flex"
                            v-if="item.installation_price_promo && dateTimeForPlansPromo(item)">
                            <h6 class="u-grey-text u-bold u-line-through ml-auto flex-grow-1 text-right pr-1">
                                {{ formatPrice(item.installation_price)}} </h6>
                            <h6 class="u-orange u-bold ml-auto"> {{ formatPrice(item.installation_price_promo) }}</h6>
                        </div>
                        <div class="u-flex" v-else>
                            <h6 class="u-orange u-bold ml-auto"> {{ formatPrice(item.installation_price) }}</h6>
                        </div>

                        <!-- <div class="fiber__description u-grey-text">
                            <span
                                v-if="charac.price.plan_promo_subscription_duration && charac.price.plan_promo_subscription_duration.length > 0 && dateTimeForPlansPromo(charac)"
                                v-html="textPromoPriceDiscount(charac.price.plan_promo_subscription_duration, charac.price.old_price_plan)">
                            </span>
                        </div> -->
                        <span class="u-block text-right u-grey-text small-text" v-html="item.installation_price_description"></span>
                    </div>
                </div>
            </div>
        </template>

        <div>
            <a
                :tabindex="addToCartButtonState.tabindex"
                role="button"
                id="validate-plan"
                :aria-disabled="addToCartButtonState.disabled"
                @click="validatePlan"
                :href="planDataFromMagento.cartUrl"
                :class="['btn btn-lg btn-primary', addToCartButtonState.disabled ? 'disabled' : '']">
                <span>{{ $t('Add to basket')}}</span>
                <img
                    v-show="addToCartButtonState.disabled"
                    :src="planDataFromMagento.loaderUrl"
                    class="u-marg-l-xxs"
                    style="max-width: 16px;"
                    alt=""/>
            </a>
        </div>
    </form>
</template>

<script>

  export default {
    props: {
        planDataFromMagento: {
            type: Object,
            default: () => undefined
        },
        traduction: {
            type: Function
        },
    },
    data () {
        return {
            addToCartButtonState: {
                tabindex: 1,
                disabled: false
            },
            localData: {
                discoverSim: 'Découvrir la eSIM',
                validatePlan: 'Valider mon forfait',
                options: []
            },
        }
    },
      mounted(){
          window.dataLayer.push({
              'event': 'configurator_field',
              'step': 'fibre_installation_step'
          });
      },

      computed: {
        $t() {
            return this.traduction
        }
    },
      methods: {
          validatePlan(el){
              el.preventDefault()
              this.$emit('validate-plan', this.planDataFromMagento)

              this.addToCartButtonState.disabled = true
              this.addToCartButtonState.tabindex = -1
              localStorage.setItem('is_enable_livebox_for_plan', '1');
              document.cookie = "is_enable_livebox_for_plan=1; path=/";
          },
            formatPrice(price) {
              if (isNaN(parseInt(price))) {
                  return price
              }

              price = parseFloat(price);

              if (price % 1 === 0) {
                  price = parseInt(price, 10);
              } else {
                  price = price.toFixed(2);
              }

              const formattedPrice = this.planDataFromMagento.locale === 'en'
                  ? price
                  : price.toString().replace('.', ',');

              return this.planDataFromMagento.locale === 'en'
                  ? `€${formattedPrice}`
                  : `${formattedPrice}€`;
            },
          dateTimeForPlansPromo(charac) {
            //remove this
            return true

              let startDate
              let endDate

              if (charac.price.promo_date_start_1 || charac.price.promo_date_end_1) {
                  startDate = charac.price.promo_date_start_1;
                  endDate = charac.price.promo_date_end_1;
              } else {
                  return false;
              }

              let timezone = charac.price.timezone_config;
              var now = new Date();
              var currentTime = now.toLocaleString('sv-SE', {timeZone: timezone});

              return startDate <= currentTime && endDate >= currentTime

          },

          textPromoPriceDiscount(promoSubscriptionDuration, oldPrice)
          {
              if ( promoSubscriptionDuration !== '1') {

                return this.$t('for %1 months, then <br/>%2/month').replace('%1', promoSubscriptionDuration).replace('%2', oldPrice);
              } else {
                return this.$t('for %1 month,<br/> then %2/month').replace('%1', promoSubscriptionDuration).replace('%2', oldPrice);
              }

          }

      }

  }
</script>

